import axios, {AxiosResponse} from 'axios'

// List organization
const organizationList = async ({params}) => {
  const response = await axios.get('/api/organization/list', params)
  return response.data
}

// Create Or Update new organization
const organizationCreate = async ({data}) => {
  await axios.post('/api/organization/store', data)
}

// Edit organization
const organizationEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/organization/edit/${id}`)
  return response.data
}

// organizationView
const organizationView = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/organization/view/${id}`)
  return response.data
}

// Delete organization
const organizationDelete = async (id: string) => {
  await axios.get(`/api/organization/destroy/${id}`)
}

// List currency
const currencyList = async ({params}) => {
  const response = await axios.get('/api/currency/list', params)
  return response.data
}

// Create Or Update new currency
const currencyCreate = async ({data}) => {
  await axios.post('/api/currency/store', data)
}

// Edit currency
const currencyEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/currency/edit/${id}`)
  return response.data
}

// Delete currency
const currencyDelete = async (id: string) => {
  await axios.get(`/api/currency/destroy/${id}`)
}

// List student
const studentList = async () => {
  const response = await axios.get(`/api/student-invoice/get-students`)
  return response.data
}

const getStdProgram = async (id: string) => {
  const response = await axios.get(`/api/student-invoice/get-std-program/${id}`)
  return response.data
}

// get student details
const studentDetails = async (id: string, type: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/student-invoice/get-student-details/${id}/${type}`)
  return response.data
}

const studentInvoiceList = async ({params}) => {
  const response = await axios.get('/api/student-invoice/list', params)
  return response.data
}

const studentInvoiceCreate = async ({data}) => {
  await axios.post('/api/student-invoice/store', data)
}

// Delete studentInvoiceDelete
const studentInvoiceDelete = async (id: string) => {
  await axios.get(`/api/student-invoice/destroy/${id}`)
}

// get student details
const studentInvoiceDetails = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/student-invoice/view/${id}`)
  return response.data
}

// Edit studentInvoiceInvoiceEdit
const studentInvoiceInvoiceEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/student-invoice/edit/${id}`)
  return response.data
}

const getPayments = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/student-invoice/get-payments/${id}`)
  return response.data
}

const studentInvoicePaymentCreate = async ({data}) => {
  await axios.post('/api/student-invoice/store-payment', data)
}

// invoicePrint
const invoicePrint = async (id: string) => {
  const res = await axios.get(`/api/student-invoice/print/${id}`)
  return res.data
}

// email studentInvoice
const studentInvoiceEmail = async (id: string) => {
  await axios.get(`/api/student-invoice/email/${id}`)
}

const invoiceSummary = async () => {
  const response = await axios.get(`/api/student-invoice/invoice-summary`)
  return response.data
}

const changeInstallmentDate = async ({data}) => {
  await axios.post('/api/student-invoice/change-installment-date', data)
}

const paymentDelete = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/student-invoice/delete-payment/${id}`)
  return response.data
}

const stdInvoices = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/student-invoice/std-invoices/${id}`)
  return response.data
}

const orgInvoiceCreate = async ({data}) => {
  const res = await axios.post('/api/org-invoice/store', data)
  return res.data
}

const orgInvoiceList = async ({params}) => {
  const response = await axios.get('/api/org-invoice/list', params)
  return response.data
}

const orgInvoices = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/org-invoice/org-invoices/${id}`)
  return response.data
}

const orgInvoiceInvoiceEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/org-invoice/edit/${id}`)
  return response.data
}

const orgInvoiceDelete = async (id: string) => {
  await axios.get(`/api/org-invoice/destroy/${id}`)
}

const orgInvoiceDetails = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/org-invoice/view/${id}`)
  return response.data
}

const orgChangeInstallmentDate = async ({data}) => {
  await axios.post('/api/org-invoice/change-installment-date', data)
}

const getOrgPayments = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/org-invoice/get-payments/${id}`)
  return response.data
}

const orgInvoicePaymentCreate = async ({data}) => {
  await axios.post('/api/org-invoice/store-payment', data)
}

const orgInvoicePrint = async (id: string) => {
  const res = await axios.get(`/api/org-invoice/print/${id}`)
  return res.data
}

const orgPaymentDelete = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/org-invoice/delete-payment/${id}`)
  return response.data
}

const orgInvoiceEmail = async (id: string) => {
  await axios.get(`/api/org-invoice/email/${id}`)
}

const orgInvoiceSummary = async () => {
  const response = await axios.get(`/api/org-invoice/invoice-summary`)
  return response.data
}

const getInvDetails = async (id: string) => {
  const res = await axios.get(`/api/student-invoice/get-inv-details/${id}`)
  return res.data
}

const invoiceUpdate = async ({data}) => {
  const res = await axios.post('/api/student-invoice/update-invoice', data)
  return res.data
}

const getInvOrgDetails = async (id: string) => {
  const res = await axios.get(`/api/org-invoice/get-inv-details/${id}`)
  return res.data
}

const invoiceOrgUpdate = async ({data}) => {
  const res = await axios.post('/api/org-invoice/update-invoice', data)
  return res.data
}

const financeService = {
  getInvOrgDetails,
  invoiceOrgUpdate,
  invoiceUpdate,
  getInvDetails,
  orgInvoiceSummary,
  orgInvoiceEmail,
  orgPaymentDelete,
  orgInvoicePrint,
  orgInvoicePaymentCreate,
  getOrgPayments,
  orgChangeInstallmentDate,
  orgInvoiceDetails,
  orgInvoiceDelete,
  orgInvoiceInvoiceEdit,
  orgInvoices,
  orgInvoiceList,
  orgInvoiceCreate,
  getStdProgram,
  stdInvoices,
  paymentDelete,
  changeInstallmentDate,
  invoiceSummary,
  organizationList,
  organizationCreate,
  organizationEdit,
  organizationDelete,
  organizationView,
  currencyList,
  currencyCreate,
  currencyEdit,
  currencyDelete,
  studentList,
  studentDetails,
  studentInvoiceCreate,
  studentInvoiceList,
  studentInvoiceDelete,
  studentInvoiceDetails,
  studentInvoiceInvoiceEdit,
  getPayments,
  studentInvoicePaymentCreate,
  invoicePrint,
  studentInvoiceEmail,
}

export default financeService
